import template from './rw-remove-widget.html';

export default class RwRemoveWidgetComponent {
  constructor() {
    this.bindings = {
      action: '&',
    };
    this.template = template;
    this.controller = () => {};
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/rw-remove-widget/rw-remove-widget-component.js